import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from 'src/app/core/services/layout.service';

@Component({
  selector: 'app-bread-crumb-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './bread-crumb-view.component.html',
  styleUrls: ['./bread-crumb-view.component.scss'],
})
export class BreadCrumbViewComponent {

  constructor(private layoutService: LayoutService) { }

  get breadcrumbItems() {
    return this.layoutService.breadcrumbItems;
  }
}
